import { render, staticRenderFns } from "./MapLegendLi.vue?vue&type=template&id=36ff97f8&scoped=true&"
import script from "./MapLegendLi.vue?vue&type=script&lang=js&"
export * from "./MapLegendLi.vue?vue&type=script&lang=js&"
import style0 from "./MapLegendLi.vue?vue&type=style&index=0&id=36ff97f8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36ff97f8",
  null
  
)

export default component.exports